<script lang="ts">
    import {getLocalization} from 'src/core';
    import {getPageContext} from 'shared/layouts';
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    const localize = getLocalization();

    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();
    const user = pageContext.staticData.user;
</script>

{#if user.contacts.length > 0}
    <KpGenericPanel additionalClasses="kp-user-account-contacts-part"
                    hasBodyPadding={false}>

        <span slot="heading">
            {localize(/* @kp-localization commons.Contacts */ 'commons.Contacts')}
        </span>

        <div class="contacts-container">
            {#each user.contacts as contact}
                <div class="contact-row">
                    <span class="value">{contact.value}</span>

                    <div class="contact-tags-container">
                        {#if contact.source.id !== 'internal'}
                            <KpChipTag chipSize="xs" chipStyle="primary">{pipe(contact.source, loc())}</KpChipTag>
                        {/if}

                        <KpChipTag chipSize="xs" chipStyle="primary">{pipe(contact.type, loc())}</KpChipTag>
                    </div>
                </div>
            {/each}
        </div>
    </KpGenericPanel>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .contacts-container {
        display: flex;
        flex-direction: column;

        .contact-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            border-bottom: 1px solid @themed-border-default;
            gap: @spacing-s;
            padding: @spacing-base @spacing-ml;

            &:last-child {
                border-bottom: none;
            }

            .contact-tags-container {
                display: flex;
                flex-wrap: wrap;
                gap: 3px;
            }
        }
    }
</style>